import home from "modules/home/route";
import auth from "modules/auth/route";
import explore from "modules/explore/route";
import inbox from "modules/inbox/route";
import inboxDetail from "modules/inbox-detail/route";
import accountVerify from "modules/account-verify/route";
import inviteCode from "modules/invite-code/route";
import depositEth from "modules/deposit-eth/route";
import buyFirstShare from "modules/buy-first-share/route";
import upload from "modules/upload/route";
import profile from "modules/profile/route";
import otherProfile from "modules/other-profile/route";
import balanceProfile from "modules/profile-balance/route";
import live from "modules/live/route";
import activities from "modules/activities/route";
import point from "modules/point/route";

const mainRouters: AppRouteType[] = [
  ...home,
  ...auth,
  ...explore,
  ...inbox,
  ...profile,
  ...inboxDetail,
  ...accountVerify,
  ...inviteCode,
  ...depositEth,
  ...buyFirstShare,
  ...upload,
  ...otherProfile,
  ...balanceProfile,
  ...live,
  ...activities,
  ...point,
];

interface Props {
  children: React.ReactNode;
}

export type AppRouteType = {
  path: string;
  component: React.FC;
  container: React.FC<Props>;
  isAuthNeeded: boolean;
};

export { mainRouters };
